import { Skeleton } from "@/components/atoms";
import { usePricingProfileContext, useZoneRatesContext, ZoneRatesPanel } from "@/components/organisms";
import { ZoneRatesAdd } from "./ZoneRatesAdd";
import { Restricted } from "@/components/pages/Restricted/Restricted";
import { ZoneRatesEdit } from "./ZoneRatesEdit";

export const ZoneRates = () => {
  const { isFetching: isFetchingPricingProfile, isRestricted } = usePricingProfileContext();
  const { isFetching: isFetchingZoneRates } = useZoneRatesContext();
  const isFetching = isFetchingPricingProfile || isFetchingZoneRates;

  if (isFetching) {
    return (
      <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      {isRestricted ? <Restricted /> : <ZoneRatesPanel />}
    </div>
  );
};

ZoneRates.Add = ZoneRatesAdd;
ZoneRates.Edit = ZoneRatesEdit;